<template>
  <div class="py-4">
    <div v-if="title" class="mb-3.5 flex items-baseline">
      <p :class="cn('ui-text-m mr-1.5 font-normal capitalize', labelClass)">
        {{ title }}:
      </p>
      <div
        v-if="!hideResultNearLabel && selectedItem"
        class="text-xs text-gray-80"
      >
        {{ selectedItem.currentTranslation?.title }}
      </div>
    </div>
    <div class="flex flex-wrap gap-1.5">
      <button
        v-for="item in block.materials"
        :key="item.id"
        class="group relative flex size-8.5 flex-shrink-0 items-center justify-center rounded-full disabled:border-gray-10 disabled:bg-gray-5 disabled:text-gray-30"
        :class="selectedItem?.id === item.id ? 'border border-black' : ''"
        :disabled="!skipDisable && item.disabled"
        :aria-label="item.currentTranslation?.title"
        @click="onFilterClick(block.slug, item)"
      >
        <UiLazyImg
          class="size-6 overflow-hidden rounded-full object-contain group-disabled:opacity-50"
          :class="[
            block.slug === 'diamond-shape'
              ? 'transition-all md:group-hover:scale-[1.1]'
              : '',
          ]"
          :src="
            getImageByPosition(item.medias, 'list')?.file?.url ||
            '/images/no-image.webp'
          "
          :alt="
            getImageByPosition(item.medias, 'list')?.file?.alt ||
            getFilterImageAlt(item, block)
          "
        />
      </button>
    </div>
    <SharedFieldHint :message="errorMessage" error />
    <slot name="additional" />
  </div>
</template>

<script setup lang="ts">
import { useField } from "vee-validate";
import { IProductMaterialFilterProps, MaterialData } from "ecom-types";

const props = defineProps<
  IProductMaterialFilterProps & { skipDisable?: boolean }
>();

const emit = defineEmits<{
  (e: "filter", value: { slug: string; item: MaterialData }): void;
}>();

function getFilterImageAlt(option: MaterialData, category: any) {
  let res = "";
  if (category?.currentTranslation?.title) {
    res = res + category.currentTranslation.title;
  }
  if (option?.currentTranslation?.title) {
    res = res + " " + option.currentTranslation.title;
  }
  return res;
}

const { errorMessage, setValue } = useField(props.block?.slug, undefined, {
  initialValue: props.selectedItem?.sku,
});

watch(
  () => props.selectedItem,
  () => {
    setValue(props.selectedItem?.sku || "");
  },
  { deep: true },
);

function onFilterClick(slug: string, item: MaterialData) {
  setValue(item.sku);
  emit("filter", { slug, item });
}
</script>
